'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Move = function Move(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 1059 1024' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M501.905 61.626v441.551H78.355l81.18-94.593a17.311 17.311 0 0 0 4.164-11.294c0-9.61-7.791-17.4-17.4-17.4a17.36 17.36 0 0 0-13.216 6.082L27.176 507.766c-2.608 3.011-4.198 6.968-4.198 11.294s1.589 8.283 4.215 11.316l105.869 121.748c3.211 3.747 7.948 6.105 13.236 6.105 9.61 0 17.4-7.791 17.4-17.4 0-4.322-1.576-8.275-4.184-11.318l-79.043-91.393h421.432v423.55l-94.593-79.063a17.311 17.311 0 0 0-11.294-4.164c-9.61 0-17.4 7.791-17.4 17.4a17.36 17.36 0 0 0 6.082 13.216l121.794 105.907c3.011 2.608 6.968 4.198 11.294 4.198s8.283-1.589 11.316-4.215L650.85 909.078c3.711-3.229 6.044-7.96 6.044-13.236 0-9.673-7.842-17.515-17.515-17.515-4.397 0-8.417 1.62-11.492 4.297l-91.395 78.338V538.118h439.08l-78.357 91.416a17.311 17.311 0 0 0-4.164 11.294c0 9.61 7.791 17.4 17.4 17.4a17.36 17.36 0 0 0 13.216-6.082l105.907-121.794c2.608-3.011 4.198-6.968 4.198-11.294s-1.589-8.283-4.215-11.316L923.688 385.994c-3.211-3.747-7.948-6.105-13.236-6.105-9.61 0-17.4 7.791-17.4 17.4 0 4.322 1.576 8.275 4.184 11.318l81.161 94.57H536.846V64.45l91.063 76.944a17.311 17.311 0 0 0 11.294 4.164c9.61 0 17.4-7.791 17.4-17.4a17.36 17.36 0 0 0-6.082-13.216l-122.5-102.73c-3.011-2.608-6.968-4.198-11.294-4.198s-8.283 1.589-11.316 4.215L383.663 118.098c-3.747 3.211-6.105 7.948-6.105 13.236 0 9.61 7.791 17.4 17.4 17.4 4.322 0 8.275-1.576 11.318-4.184z'
      })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Move;